import { ssoClient } from "./sso-client";
import { useAuthStore } from "../stores/auth-store";

let refreshTimer: ReturnType<typeof setTimeout> | null = null;

const REFRESH_MARGIN_MS = 60_000;

export function startRefreshTimer(expiresAt: number) {
  stopRefreshTimer();
  const delay = Math.max(expiresAt - Date.now() - REFRESH_MARGIN_MS, 0);
  refreshTimer = setTimeout(handleRefresh, delay);
}

export function stopRefreshTimer() {
  if (refreshTimer !== null) {
    clearTimeout(refreshTimer);
    refreshTimer = null;
  }
}

async function handleRefresh() {
  const success = await refreshTokenNow();
  if (!success) {
    useAuthStore.getState().clearTokens();
    window.location.href = "/sso/login";
  }
}

export async function refreshTokenNow(): Promise<boolean> {
  const { refreshToken, realm } = useAuthStore.getState();
  if (!ssoClient || !refreshToken || !realm) return false;

  try {
    const tokens = await ssoClient.refreshToken(refreshToken, realm);
    useAuthStore.getState().setTokens(tokens);
    startRefreshTimer(Date.now() + tokens.expires_in * 1000);
    return true;
  } catch {
    return false;
  }
}
